import * as angular from "angular";
import { FeatureExtraDialogController } from "./feature-extra-dialog.controller";

let FeatureReceptionDialog = {
    selector: "vcFeatureReceptionDialog",
    templateUrl:
        "/angular/components/feature/feature-reception-dialog.component.html",
    bindings: {
        feature: "=",
        isOrgCampaign: "=?",
        openFeatureExtra: "&?",
    },
    controller: FeatureExtraDialogController,
};

angular
    .module("feature")
    .component(FeatureReceptionDialog.selector, FeatureReceptionDialog);
